import { FILE_APPLICATION_PDF, FILE_IMAGE_TIFF } from 'utils/file';

import Button from 'components/button';
import PdfDocument from 'components/icons/pdf-document';
import Delete from 'components/icons/delete';
import FileUpload from 'components/file-upload';
import { T } from 'components/translation';

import { useImportContractContext } from 'contexts/import-contract-props';

import {
  shouldRenderLoader,
  isAiImport,
} from '../utils';
import style from './import-file-upload.module.scss';

export const ImportFileUpload = () => {
  const {
    uploadDocument,
    removeFile,
    onAssetPagesDone,
    onFileUploadError,
    resetFileUploadState,
    uploadInitiated,
    pdfIsReady,
    assetUploadErrorCode,
    uploadedPdfName,
    importMethod,
    isAiImportOptionEnabled,
    prepareDocument,
  } = useImportContractContext();

  if (isAiImport(importMethod) && !isAiImportOptionEnabled) {
    return null;
  }

  return (
    <>
      <span className={style.HelperText}>
        <T
          _str="Imported documents are for archiving only."
          _comment="Helper text to make it clear to the user that imported documents are for archiving only"
        />
      </span>
      {uploadedPdfName ? (
        <div className={style.UploadedPdf}>
          <PdfDocument height="14px" />
          <span>
            {uploadedPdfName}
            .pdf
          </span>
          <Button icon={<Delete height="14px" />} onClick={removeFile}>
            <T _str="Remove" _comment="Button text to remove an uploaded document" />
          </Button>
        </div>
      ) : (
        <FileUpload
          accept={[FILE_APPLICATION_PDF, FILE_IMAGE_TIFF]}
          assetType="document"
          onUploadDone={onAssetPagesDone}
          prepare={prepareDocument}
          loading={shouldRenderLoader(
            uploadInitiated,
            pdfIsReady,
            assetUploadErrorCode,
          )}
          onUpload={uploadDocument}
          onError={onFileUploadError}
          resetUploadState={resetFileUploadState}
          isSmall
        />
      )}
    </>
  );
};
